import { createCallchainHttp } from './callchain-http.js'

const GROUP_QUERY_KEYS = new Set(['q', 'status', 'scenario_id', 'ending_id'])
const QUERY_KEYS = new Set([...GROUP_QUERY_KEYS, 'limit', 'offset'])

let http = createUnconfiguredHttp()

/** @param {Parameters<typeof createCallchainHttp>[0]} opts */
export function configureGenerationRecordsHttp(opts) {
  http = createCallchainHttp({ ...opts, basePath: '/api' })
}

/**
 * @callchain.routeId visualGame.generationRecords.list
 * @param {Record<string, string|number|null|undefined>} query
 */
export async function listGenerationRecords(query) {
  assertAllowedQuery(query, QUERY_KEYS)
  return http.get('/admin/visual-game/generation-records', {
    query,
    routeId: 'visualGame.generationRecords.list',
  })
}

/**
 * @callchain.routeId visualGame.generationRecords.groups
 * @param {Record<string, string|null|undefined>} query
 */
export async function listGenerationRecordGroups(query) {
  assertAllowedQuery(query, GROUP_QUERY_KEYS)
  return http.get('/admin/visual-game/generation-records/groups', {
    query,
    routeId: 'visualGame.generationRecords.groups',
  })
}

/**
 * @callchain.routeId visualGame.generationRecords.scenarios
 */
export async function listGenerationRecordScenarios() {
  return http.get('/admin/visual-game/generation-records/scenarios', {
    routeId: 'visualGame.generationRecords.scenarios',
  })
}

/**
 * @callchain.routeId visualGame.generationRecords.process
 * @param {string} videoId
 */
export async function getGenerationRecordProcess(videoId) {
  return http.get(`/admin/visual-game/generation-records/videos/${encodeURIComponent(videoId)}/process`, {
    routeId: 'visualGame.generationRecords.process',
  })
}

/**
 * @callchain.routeId visualGame.generationRecords.updateVideoCopy
 * @param {string} videoId
 * @param {{ title: string, summary: string }} body
 */
export async function updateGenerationRecordVideoCopy(videoId, body) {
  return http.patch(`/admin/visual-game/generation-records/videos/${encodeURIComponent(videoId)}/copy`, {
    body,
    routeId: 'visualGame.generationRecords.updateVideoCopy',
  })
}

/** @param {Record<string, unknown>} query @param {Set<string>} allowedKeys */
function assertAllowedQuery(query, allowedKeys) {
  for (const key of Object.keys(query)) {
    if (!allowedKeys.has(key)) {
      throw new Error(`Unknown generation records query key: ${key}`)
    }
  }
}

function createUnconfiguredHttp() {
  return {
    get() {
      throw new Error('configureGenerationRecordsHttp must be called before generation records API use')
    },
    patch() {
      throw new Error('configureGenerationRecordsHttp must be called before generation records API use')
    },
  }
}
